<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px">
                <el-row :gutter="10">
                  <el-col>
                    <el-form-item label="输入搜索：">
                      <el-col :span="2">
                        <el-input
                          v-model="form.work_order_id"
                          placeholder="客服工单id"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.user_id"
                          placeholder="用户id"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-select v-model="form.type" placeholder="无数据类型">
                          <el-option value="0" label="全部"></el-option>
                          <el-option value="1" label="无信息"></el-option>
                          <el-option value="2" label="无工单"></el-option>
                          <el-option
                            value="3"
                            label="工单数据不一致"
                          ></el-option>
                          <el-option value="4" label="疑似人为"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.goods_no"
                          placeholder="商品货号"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.mobile"
                          placeholder="用户手机"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.express_no"
                          placeholder="寄回运单号"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.handle_admin"
                          placeholder="跟进人"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="7">
                    <el-form-item label="拆包时间：">
                      <el-date-picker
                        v-model="form.create_time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="7">
                    <el-form-item label="跟进时间：">
                      <el-date-picker
                        v-model="form.handle_time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="2">
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="create_time"
              label="拆包时间"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="work_order_id"
              label="客服工单id"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="no_data_work_type"
              label="无数据类型"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="express_no"
              label="寄回运单号"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="goods_img"
              label="商品图片"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <div style="width: 70px; height: 70px">
                  <img
                    :src="scope.row.goods_img"
                    style="width: 100%; height: 100%"
                    @click="showImages(scope.row.img)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="mobile"
              label="用户手机"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="user_id"
              label="用户ID"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_num"
              label="件数"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="space"
              label="仓位"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="reject_remark"
              label="售后备注"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle_admin"
              label="跟进人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle_remark"
              label="跟进人备注"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle_time"
              label="跟进时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle_time"
              label="操作"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click="handleNoDataWork(scope.row.id)"
                  >备注</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import PreviewImage from "../../components/PreviewImage";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: { PreviewImage },
  data() {
    return {
      showbox: false,
      images: [],
      resData: null,
      form: {
        create_time: this.defaultDate(),
        status: "",
        referer: 1,
      },
      loading: false, // 加载动画是否显示
      url: "/erp/Work/noDataWorkList",
      status: "",
      curPage: 1,
      loading: false,
      tableLoading: false,
      filterFold: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.form.create_time = this.defaultDate();
    this.fetchData();
  },
  methods: {
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    showImages(img) {
      this.showbox = true;
      this.images = img;
    },
    closeBox() {
      this.showbox = false;
    },
    handleNoDataWork(id) {
      this.$prompt("填写备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showInput: true,
      })
        .then(({ value }) => {
          if (!value) {
            return this.$message.warning("请填写备注");
          }
          const arg = { id, remark: value };
          this.loading = true;
          this.$http.post("/erp/Work/addNoDataWorkRemark", arg).then((res) => {
            this.loading = false;
            if (res.data.code != 200) {
              return this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
            this.fetchData();
            return this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    handleClick(row) {},
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    selectStatus(key) {
      this.form.status = this.status = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.demo-form-inline .el-form-item {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/work/NoDataWorkList.vue